export enum AgentAssistStatus {
   NEGATIVE = 'Negative Score',
   POSITIVE ='Positive Score',
   INITIAL = 'Initial Score',
   INTERMEDIATE = 'Intermediate Score',
  }